import styled from "styled-components";

export const Select = styled.select`
  width: 40%;
  max-width: 220px;
  height: 45px;
  border: 1px solid #dcdcdc;
  padding: 0 10px;
  font-size: 1.05rem;
  border-radius: 5px;
`;
